import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Context from "./constants/Context";

window.__RSL_FRONTEND_BUILD__ = "play-cricket-logs-v2";

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister();
    });
  });
}

if (window.caches && caches.keys) {
  caches.keys().then((keys) => {
    keys.forEach((key) => caches.delete(key));
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(

    <Context>
      <App />
    </Context>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
